<template>
  <div>
    <div class="ipub-h1 mar-b-20">Decline Invitation</div>
    <div class="part mar-b-40">
      <div class="ipub-h4 mar-b-12">Reason for Reject Review</div>
      <div class="mar-b-20 ipub-p1">{{reviewRefuse[inputData.reasonCode]}}</div>
      <div class="text ipub-p2"
           style="margin-bottom:25px">{{inputData.reason}}</div>
      <div>
        <span class="ipub-p1"
              style="margin-right:12px"
              v-if="inputData.reviewerList && inputData.reviewerList.length>0">Suggested reviewer’s name</span>
        <span v-for="(item,index) in inputData.reviewerList"
              :key="index"
              style="color:#1E1D40;margin-right:12px">
          {{item.firstName}} {{item.lastName}} - {{item.email}}
        </span>
      </div>
    </div>
    <ipub-button @click="confirm"
                 type="primary"
                 :style="{ minWidth: '150px' }">Confirm</ipub-button>

  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
.part {
  background: #fff;
  padding: 20px 20px 30px;

  .text {
    background: #fff;
    min-height: 200px;
    border-radius: 4px;
    border: 1px solid #e9eef0;
    padding: 10px 10px 20px;
  }
}
</style>

<script>
import main from './main'
export default main
</script>
